import type { Styles } from '@adornis/ass/style.js';
import { XFlatLoader } from '@adornis/chemistry/elements/components/x-flat-loader.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-flat-loader
 */
@customElement('cr-flat-loader')
export class ChromiumFlatLoader extends XFlatLoader {
  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        '@keyframes slide': { '0%': { backgroundPosition: '-500px 0' }, '100%': { backgroundPosition: '468px 0' } },
        display: 'block',
        flexShrink: '0',
        height: '1em',
        borderRadius: '1em',
        background: `linear-gradient(to right, transparent 8%, ${this.colors.primary.shade(100)} 38%, transparent 54%)`,
        backgroundSize: '1000px 640px',
        animation: 'slide 1.5s cubic-bezier(0.3, 0.1, 0.3, 0.85) infinite',
      },
    ];
  }
}
